import { extend } from "lodash";

export class FilterOption {
  public Section: Array<FilterSection>
}

export class FilterSection {
  public Titre?: string;

  public FilterProperty: Array<FilterProperty>

}

export class FilterBadgeModel {
  //type de filtre pour gerer le render 
  public PropType: FilterPropertyType;
  //Cle unique (nom de la colonne pour le requete )
  public PropKey: string;
  //Valeur du filter (elle peut etre en any sur le front, mais toujours en string pour l'envoi serveur )
  public PropValue?: string | any;
  //Operator pour effectuer le requete
  public PropOperator: Operator;
  // Spécifie si le filtre sera pris en compte dans la construction du where de la requête, ou s'il s s'un filtre qui a besoin de traitement particulier
  public PropInWhere?: boolean;


  //definit l'order dans le quel le badge va ete dans la liste des badges
  public Order?: number;
  // texte sur le badge
  public Text: string;
  // valeur a afficher sur le badge
  public Value?: string;

  // le badge ne s'affiche pas dans le composant badge
  public Hidden?: boolean;
  // le badge vient des params du treeview
  public Treeview?: boolean;

  public Loaded?: boolean;
}

export class FilterProperty extends FilterBadgeModel {
  //option relative au type de propriété
  public PropTypeOption?: any;
  //afficher ou pas un selecteur d'operateur (pas implementé sur chaque type de propriété)
  public ShowOperator?: boolean;
  //definit le largeur d'un filtre par rapport aux autres 
  public PropWidth?: any;

  // Condition d'affichage
  public ConditionToShow?: string;
}

export class FilterModelModel {
  public GroupMOD: string;
  public Code_MOD: string;
  public Info_MOD: string;
  public Filter: Array<FilterBadgeModel>;

  constructor() {
    this.Filter = new Array<FilterBadgeModel>();
  }
}



export enum FilterPropertyType {
  /**
   * PropTypeOption = liste de select
   * */
  Select,
  Check,
  /**
   * PropTypeOption = objet avec les inputs du composant
   * */
  AvatarSearch,
  InputNumber,
  /**
 * PropTypeOption = objet avec les inputs du composant
 * */
  DateRange,
  /**
   * PropKey = string qui va etre retourné par l'output SendEvent pour identifier le bonton (Si PropKey est egale a un propkey d'un autre filtre, ils vont se coller l'un a l'autre)
   * */
  Button,
  /**
* PropTypeOption = objet avec les inputs du composant
* */
  Tag,

  QuickSearch,
  ProduitAction,
  /**
* PropTypeOption = radio group name
* */
  Radio,
  NumberRange,
}

export enum Operator {
  In,
  Egale,
  Superieur,
  Inferieur,
  SuperieurEgale,
  InferieurEgale,
}
